import { createReducer, createActions } from "reduxsauce"

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  toggleMap: null,
  toggleRateMenu: null
})

export const UITypes = Types
export default Creators

export const INITIAL_STATE = {
  isMapToggled: false,
  isRateMenuToggled: false
}

export const toggleMap = state => ({ ...state, isMapToggled: true })

export const toggleRateMenu = state => ({
  ...state,
  isRateMenuToggled: !state.isRateMenuToggled
})

export const reducer = createReducer(INITIAL_STATE, {
  [Types.TOGGLE_MAP]: toggleMap,
  [Types.TOGGLE_RATE_MENU]: toggleRateMenu
})



// WEBPACK FOOTER //
// ./src/redux/ui.redux.js